<app-page-header icon="admin_panel_settings" title="Roles" subtitle="Alta, baja y modificación de roles del sistema"></app-page-header>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando roles...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button mat-stroked-button class="btn-crear" (click)="crearNuevo()">
        <mat-icon>add</mat-icon> Crear nuevo rol
      </button>
    </div>

    <mat-form-field class="buscador" appearance="outline">
      <mat-label>Buscar rol</mat-label>
      <span class="material-icons" matPrefix>search</span>
      <input
        matInput
        [ngModel]="termino"
        (ngModelChange)="aplicarFiltro($event)"
        placeholder="Key, descripción..."
        autocomplete="off"
      />
    </mat-form-field>

    <div class="mat-elevation-z8 tabla-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Rol </th>
          <td mat-cell *matCellDef="let p">
            <code>{{ p.key }}</code>
          </td>
        </ng-container>

        <ng-container matColumnDef="descripcion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción </th>
          <td mat-cell *matCellDef="let p"> {{ p.descripcion || '-' }} </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let p">
            <button mat-icon-button color="primary" title="Editar" (click)="editarPerfil(p)">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No hay registros que coincidan con "{{ termino }}".
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Seleccionar página"></mat-paginator>
    </div>
  </div>
</div>
